import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Helmet } from 'react-helmet';

type BookingModalProps = {
  open?: boolean;
  onClose?: () => void;
};

const OpenTableWidget: React.FC = () => {
	const containerRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (!containerRef.current) return;
		containerRef.current.innerHTML = '';

		const script = document.createElement('script');
		script.src = '//www.opentable.co.th/widget/reservation/loader?rid=306800&type=standard&theme=standard&color=1&dark=false&iframe=true&domain=coth&lang=en-US&newtab=false&ot_source=Restaurant%20website&cfe=true';
		script.async = true;
		script.type = 'text/javascript';

		containerRef.current.appendChild(script);

		return () => {
			if (containerRef.current) {
				containerRef.current.innerHTML = '';
			}
		};
	}, []);

	return (
		<Box
			ref={containerRef}
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100%',
				minHeight: '500px',
			}}
		/>
	);
};

const BookingModal: React.FC<BookingModalProps> = ({ open, onClose }) => {
  const isControlled = typeof open === 'boolean' && typeof onClose === 'function';
  const [internalOpen, setInternalOpen] = useState(false);

  const handleInternalOpen = () => setInternalOpen(true);
  const handleInternalClose = () => {
    setInternalOpen(false);
  };

  const handleClose = () => {
    isControlled ? onClose?.() : handleInternalClose();
  };

  const modalOpen = isControlled ? open : internalOpen;

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>

      {/* Render internal trigger button only if uncontrolled */}
      {!isControlled && (
        <Box>
          <Button
            variant="contained"
            onClick={handleInternalOpen}
            sx={{
              bgcolor: '#A52A2A',
              color: '#fff',
              padding: '16px 32px',
              fontSize: '18px',
              width: '100%',
            }}
          >
            Book a Table
          </Button>
        </Box>
      )}

      <Dialog open={modalOpen} onClose={handleClose} fullWidth maxWidth="sm" scroll="paper">
        <DialogTitle>
          Booking Details — you can also call: 080 890 4417
        </DialogTitle>

        <DialogContent dividers>
          <OpenTableWidget />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default BookingModal;
